// extracted by mini-css-extract-plugin
export default {"container":"BI_CuD","registrationButtonSpacing":"Zzi0W3","registrationButtonSpacing--noImage":"G3YsOd","registrationButtonSpacingNoImage":"G3YsOd"};